export function normalizeTechnicianColumnStack(value) {
  const n = Number(value);
  if (n === 2 || n === 3) return n;
  return 1;
}

export function normalizeOpenColumnMinimized(value) {
  return value === true || value === 1 || value === '1';
}

/** Grava preferências no perfil (PUT /api/users/me). Não bloqueia o board. */
export function persistBoardViewPrefs(apiBase, prefs) {
  const base = String(apiBase || '').replace(/\/$/, '');
  return fetch(`${base}/api/users/me`, {
    method: 'PUT',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(prefs),
  }).catch(() => null);
}
